export default __webpack_public_path__ + "static/media/all_inclusive.cb2b1dcd.svg";